/*
  Add here your own custom javascript codes
*/

/*
  Gift wrap box in the cart drawer (snippets/cart-gift-wrap.liquid). Added 22 Oct 2026.
  Adds, switches and removes the Gift Wrapping line, keeps it at one per order,
  and saves the gift message to the order note.
*/
class GiftWrap extends HTMLElement {
  connectedCallback () {
    if (this.dataset.ready) return
    this.dataset.ready = 'true'
    customElements.whenDefined('cart-container').then(() => this.init())
  }

  init () {
    this.cart = this.closest('cart-container')
    if (!this.cart) return

    if (this.dataset.fix) {
      this.post('update', { updates: JSON.parse(this.dataset.fix) })
      return
    }

    if (this.dataset.switchKey) {
      this.switchTo(this.dataset.switchKey, this.dataset.firstVariant)
      return
    }

    const toggle = this.querySelector('[data-gw-toggle]')
    if (toggle) {
      toggle.addEventListener('change', async () => {
        toggle.disabled = true
        if (toggle.checked) {
          await this.post('add', { items: [{ id: Number(this.dataset.firstVariant), quantity: 1 }] })
        } else if (this.dataset.lineKey) {
          await this.saveNote()
          await this.post('change', { id: this.dataset.lineKey, quantity: 0 })
        }
        if (this.isConnected) {
          toggle.disabled = false
          toggle.checked = Boolean(this.dataset.lineKey)
        }
      })
    }

    this.querySelectorAll('[data-gw-option]').forEach(option => {
      option.addEventListener('change', async () => {
        if (!option.checked || !this.dataset.lineKey) return
        await this.saveNote()
        await this.switchTo(this.dataset.lineKey, option.value)
      })
    })

    this.note = this.querySelector('textarea[name="note"]')
    const opener = this.querySelector('[data-gw-message-open]')
    const message = this.querySelector('[data-gw-message]')
    if (opener && message) {
      opener.addEventListener('click', () => {
        message.hidden = false
        opener.hidden = true
        if (this.note) this.note.focus()
      })
    }
    if (this.note) {
      this.note.addEventListener('input', () => {
        clearTimeout(this.noteTimer)
        this.noteTimer = setTimeout(() => this.saveNote(), 600)
      })
      this.note.addEventListener('blur', () => this.saveNote())
    }
  }

  async switchTo (lineKey, variantId) {
    this.cart.classList.add('loading')
    try {
      await fetch(`${window.Shopify.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
    } catch (e) {}
    await this.post('add', { items: [{ id: Number(variantId), quantity: 1 }] })
  }

  async saveNote () {
    clearTimeout(this.noteTimer)
    if (!this.note || this.note.value === this.note.defaultValue) return
    const value = this.note.value
    try {
      await fetch(`${window.Shopify.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: value }),
        keepalive: true
      })
      this.note.defaultValue = value
    } catch (e) {}
  }

  async post (action, body) {
    const route = { add: 'cart_add_url', change: 'cart_change_url', update: 'cart_update_url' }[action]
    this.cart.classList.add('loading')
    try {
      const response = await fetch(`${window.Shopify.routes[route]}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, body, {
          sections: ['cart-count-badge', 'offcanvas-cart'],
          sections_url: window.location.pathname
        }))
      })
      const data = await response.json()
      if (response.ok && data.sections) {
        this.cart.reloadCartElements(data.sections)
      } else if (!response.ok) {
        this.cart.showError(data.description || data.message)
      }
    } catch (e) {}
    this.cart.classList.remove('loading')
  }
}

if (!customElements.get('gift-wrap')) customElements.define('gift-wrap', GiftWrap)